import { Component } from "react";
import { Btn, EmptyState } from "./ui";

export class PageBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Dashboard page error", error, info);
  }

  componentDidUpdate(previousProps) {
    if (previousProps.pageKey !== this.props.pageKey && this.state.error) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="page-error">
        <EmptyState title="화면을 표시하지 못했습니다" msg={this.state.error.message || "예상하지 못한 오류가 발생했습니다."} />
        <Btn onClick={() => this.setState({ error: null })}>다시 시도</Btn>
      </div>
    );
  }
}

export function PageFallback() {
  return (
    <div className="page-fallback" role="status" aria-label="화면 불러오는 중">
      <span /><span /><span />
    </div>
  );
}

